import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-redirect',
  templateUrl: './external-redirect.component.html'
})
export class ExternalRedirectComponent implements OnInit {
  ngOnInit(): void {
    window.location.href = 'https://fcsalzburg.sharepoint.com/sites/klubportal/';
  }
}